import React, { createContext, useContext, useState } from 'react';
import { createBrowserRouter, RouterProvider, useRouteError } from 'react-router';
import { QueryParamProvider } from 'src/helpers/queryParam';

const ResQRouterChildrenContext = createContext<React.ReactNode>(null);

const ResQRouterChildren = () => useContext(ResQRouterChildrenContext);

const ResQRouterError = () => {
    // Keep route render failures owned by App's outer Sentry ErrorBoundary.
    throw useRouteError();
};

export const ResQRouter = ({ children }: { children: React.ReactNode }) => {
    const [router] = useState(() => {
        let router: ReturnType<typeof createBrowserRouter>;
        router = createBrowserRouter([
            {
                path: '*',
                element: (
                    <QueryParamProvider
                        getRouterSnapshot={() => ({
                            location: router.state.location,
                            pendingLocations: [
                                ...(router.state.navigation.location
                                    ? [router.state.navigation.location]
                                    : []),
                                ...Array.from(router.state.blockers.values()).flatMap((blocker) =>
                                    blocker.state === 'unblocked' ? [] : [blocker.location],
                                ),
                            ],
                        })}
                    >
                        <ResQRouterChildren />
                    </QueryParamProvider>
                ),
                errorElement: <ResQRouterError />,
            },
        ]);
        return router;
    });

    return (
        <ResQRouterChildrenContext.Provider value={children}>
            <RouterProvider router={router} />
        </ResQRouterChildrenContext.Provider>
    );
};
